import React from "react";
import { Typography } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
const { Title } = Typography;

export const HelpGeneralConcept = () => {
  return (
    <>
      <Title level={5}>
        <QuestionCircleOutlined />
        &nbsp;Resource Portal Definitions
      </Title>
      <ul>
        <li>
          <b>Service Collections</b> are top level categories, where Eligibility
          criteria apply. They can contain multiple Service Applications that
          may host resources.
          <br />
          They are created by Resource Portal administrators only, if you need a
          new Service Collection please create a SNOW ticket.
        </li>
        <li>
          <b>Service Applications</b> are web applications, desktop
          applications, cloud applications or even virtual applications to which
          users can subscribe to gain access and eventually obtain licences.
        </li>
        <li>
          <b>Subscription Settings</b> is the configuration specifying how users
          are subscribed to the Service Application, either automatically, or
          self service via this portal.
        </li>
        <li>
          <b>Managed Resource Types</b> can optionally be created if the Service
          Application will host (reassignable) Resources for the users, such as
          databases, disk spaces, web sites, virtual machines, etc. The Resource
          Types define Resource settings such as grace periods and urls to
          create and manage them.
        </li>
        <li>
          <b>Resources</b> are owned by the user, managed by an administrator
          group, and are following a lifecycle defined by their Managed Resource
          Type.
        </li>
      </ul>
    </>
  );
};
